import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { Fragment } from 'react'
import { X } from '@/components/icons/outline'

export default function Modal({ onClose, isOpen, title, content, size = 'xl', closable = true, scaleAnimation = true }) {
    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={onClose}>
                    <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <div className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-sm" />
                    </TransitionChild>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center">
                            <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom={`${scaleAnimation ? 'sm:scale-95' : ''} opacity-0 sm:translate-y-0 translate-y-8`} enterTo={`${scaleAnimation ? 'sm:scale-100' : ''} opacity-100 translate-y-0`} leave="ease-in duration-200" leaveFrom={`${scaleAnimation ? 'sm:scale-100' : ''} opacity-100 sm:translate-y-0 translate-y-8`} leaveTo={`${scaleAnimation ? 'sm:scale-95' : ''} opacity-0 sm:translate-y-0 translate-y-8`}>
                                <DialogPanel className={`max-w-${size} relative w-full p-6 text-left align-middle transition-all transform bg-white shadow-xl rounded-3xl`}>
                                    <div className="absolute flex items-center justify-between inset-x-6 -top-12">
                                        <DialogTitle as="h3" className="text-lg font-medium leading-6 text-white">
                                            {title}
                                        </DialogTitle>
                                        {closable && (
                                            <button onClick={onClose} class="inline-flex items-center p-2 transition text-white active:hover:scale-90">
                                                <X className="w-6 h-6" stroke={1.5} />
                                            </button>
                                        )}
                                    </div>
                                    {content}
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}